import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { apiRequest } from '../../utils';
import Modal from '../elements/Modal';
import Icon from './Icon';
import './ContactPersonChoiceModal.css';

// Shown on the home screen to contact persons. Staying in the contact-person
// view (the primary choice, listed first) is where they manage the company,
// edit players and order things; switching to the player view is for joining a
// team and playing the game themselves.
// "Player" goes straight to the player card of THIS event (or the only player card they
// hold) — the full role picker only when that is genuinely ambiguous. Sending everybody
// through /role asked a community owner who had just said "player" the same thing again.
const PLAYER_KEYS = ['plgPlayer', 'legacyPlayer'];

const ContactPersonChoiceModal = ({ show, onClose, eventId }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [switching, setSwitching] = useState(false);

  const sameId = (a, b) => String(a || '').toLowerCase() === String(b || '').toLowerCase();

  const goPlayer = async () => {
    if (switching) return;
    setSwitching(true);
    try {
      const { descriptors = [] } = await apiRequest('GET', '/role');
      const players = descriptors.filter((d) => PLAYER_KEYS.includes(d.key));
      const card = (eventId && players.find((d) => sameId(d.event_id, eventId)))
        || (players.length === 1 ? players[0] : null);
      if (!card) {
        navigate('/role');
        return;
      }
      const res = await apiRequest('POST', '/role', {
        key: card.key, role: card.role, bu_id: card.bu_id,
        company_id: card.company_id, team_id: card.team_id,
      });
      // The NavBar reads its role from sessionStorage; keep it in step with the new JWT.
      sessionStorage.setItem('role', card.role);
      window.location.href = (res && res.redirect) || card.redirect || '/home';
    } catch (err) {
      navigate('/role');
    }
  };

  return (
    <Modal show={show} title={t('contactPersonChoiceTitle')} onClose={onClose} hideFooter>
      <p className="cp-choice__sub">{t('contactPersonChoiceSub')}</p>

      <button
        type="button"
        className="cp-choice cp-choice--contact"
        onClick={onClose}
      >
        <span className="cp-choice__icon">
          <Icon name="user-crown" theme="light" />
        </span>
        <span className="cp-choice__body">
          <span className="cp-choice__title">{t('contactPersonChoiceStayTitle')}</span>
          <span className="cp-choice__desc">{t('contactPersonChoiceStayDesc')}</span>
        </span>
        <Icon name="angle-right" className="cp-choice__chevron" />
      </button>

      <button
        type="button"
        className="cp-choice cp-choice--player"
        onClick={goPlayer}
        disabled={switching}
      >
        <span className="cp-choice__icon">
          <Icon name="running" theme="light" />
        </span>
        <span className="cp-choice__body">
          <span className="cp-choice__title">{t('contactPersonChoicePlayerTitle')}</span>
          <span className="cp-choice__desc">{t('contactPersonChoicePlayerDesc')}</span>
        </span>
        <Icon name="angle-right" className="cp-choice__chevron" />
      </button>
    </Modal>
  );
};

export default ContactPersonChoiceModal;
